import "../Styles/Frontend/frontend.scss";
import "../Styles/Frontend/ai-summary.scss";
import "../Styles/Frontend/table-prompt.scss";
import "../Styles/Frontend/lightbox.scss";

import "./Chunk/Frontend/data_tables_async";
import "./Chunk/Frontend/data_table_default";
import "./Chunk/Frontend/create_tab";
import "./Chunk/Frontend/ai_summary";
import "./chunk/frontend/table_prompt";
import "./chunk/frontend/lightbox_init";